import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const LabList = styled.ul`
    list-style: none;
`

export const LabItem = styled.li`
    padding: 0 16px;
    cursor: pointer;
    position: relative;

    &.active {
        background-color: rgb(240, 243, 255);
    }

    > .icon {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: ${theme.colors.primary};
        width: 20px;
        height: 20px;
    }
`

export const LabTitle = styled.li`
    padding: 16px 0;
    display: block;
    border-bottom: 1px solid #e4e5e7;
`

export const StyledForm = styled.div`
    height: auto;
    max-width: 434px;
    margin-top: 1.5rem;

    @media (min-width: ${theme.breakpoints[2]}) {
        margin-top: 2rem;
    }

    .form__login {
        margin-top: 16px;
    }

    .form__login > div {
        height: 3.5rem;
    }

    .form__login > * {
        margin-bottom: 32px;
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .form__helper-button {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;

        span {
            color: ${theme.colors.grays[50]};
            font-size: 12px;
            padding: 4px;
        }
    }

    .form__subtitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 32px 0;
        font-size: 14px;
    }

    .form__subtitle__link {
        width: 100%;
        text-align: center;
    }

    button {
        width: 100%;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        .form__login {
            margin-bottom: 8px;
        }

        form {
            display: initial;
            height: initial;
        }
    }

    input {
        padding: 1rem 0.5rem;
    }
`
